/**
 * Simple Tooltip Component
 * Using CSS-based tooltips until @radix-ui/react-tooltip is added
 */

import React from 'react';
import { cn } from '../../lib/utils';

const Tooltip = ({ children, content, side = 'top', className, ...props }) => {
  return (
    <div className="relative inline-block group" {...props}>
      {children}
      <div
        className={cn(
          "absolute z-50 px-2 py-1 text-xs text-white bg-gray-900 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap",
          side === 'top' && "bottom-full left-1/2 transform -translate-x-1/2 mb-1",
          side === 'bottom' && "top-full left-1/2 transform -translate-x-1/2 mt-1",
          side === 'left' && "right-full top-1/2 transform -translate-y-1/2 mr-1",
          side === 'right' && "left-full top-1/2 transform -translate-y-1/2 ml-1",
          className
        )}
      >
        {content}
        {/* Arrow */}
        <div
          className={cn(
            "absolute w-0 h-0",
            side === 'top' && "top-full left-1/2 transform -translate-x-1/2 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900",
            side === 'bottom' && "bottom-full left-1/2 transform -translate-x-1/2 border-l-4 border-r-4 border-b-4 border-transparent border-b-gray-900",
            side === 'left' && "left-full top-1/2 transform -translate-y-1/2 border-t-4 border-b-4 border-l-4 border-transparent border-l-gray-900",
            side === 'right' && "right-full top-1/2 transform -translate-y-1/2 border-t-4 border-b-4 border-r-4 border-transparent border-r-gray-900"
          )}
        />
      </div>
    </div>
  );
};

export { Tooltip };